export const AppPermissions = {
    // Main permissions
    PortalAccess: 'SBR.ReportsPortalAccess@SBR',
    // Reports Permissions
    PlayerReports: 'SBR.GetPlayerReports@SBR',
    SessionReports: 'SBR.GetSessionReports@SBR',
    UmpireReports: 'SBR.GetUmpireReport@SBR',
    // Default Layout Editing Permissions
    DefaultLayoutEdit: 'SBR.EditReportLayout@SBR',
    // Admin Permission
    Admin: 'SB.Admin@SB',
};
